import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const formatRealtimeData = (dataWeb) => {
    const normalizeDate = (fecha) => {
        if (!fecha) return ' ';

        if (dayjs(fecha, "DD-MM-YYYY", true).isValid()) {
            return dayjs(fecha, "DD-MM-YYYY").format("YYYY-MM-DD");
        }

        if (dayjs(fecha, "YYYY-MM-DD", true).isValid()) {
            return fecha;
        }

        return ' ';
    };
    
    try {
        const trimmedData = Object.fromEntries(
            Object.entries(dataWeb).map(([key, value]) => [key, typeof value === 'string' ? value === ' ' ? value : value.toUpperCase().trim() : value])
        );
        const camposCompletos = {
            0: trimmedData.disparo1Tajo ? trimmedData.disparo1Tajo : trimmedData.disparo2Tajo ? ' ' : 'SIN -',
            1: trimmedData.disparo2Tajo ? trimmedData.disparo2Tajo : trimmedData.disparo1Tajo ? ' ' : 'DISP ARO',
            2: trimmedData.disparo1Tajo ? trimmedData.disparo1Nivel : ' ',
            3: trimmedData.disparo2Tajo ? trimmedData.disparo2Nivel : ' ',
            4: trimmedData.disparo1Tajo ? trimmedData.disparo1Hora : ' ',
            5: trimmedData.disparo2Tajo ? trimmedData.disparo2Hora : ' ',
            6: normalizeDate(trimmedData.fecha),
        }
        return camposCompletos
    } catch (error) {
        console.error('Error en formatData:', error);
        return {};
    }
}
